var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('calendarBreadcrumbs',{attrs:{"link":'dashboardFormBuilder'}}),_c('div',{staticClass:"flix-form-group"},[_c('transition',{attrs:{"name":"flixFadeIn"}},[(_vm.data)?_c('formBuilder',{key:_vm.key,attrs:{"form":_vm.data.form}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }